/* ============================================================
   Anya localization
   - Country/currency selector dropdowns ([data-loc-selector])
   - First-visit "Set your location" bar ([data-location-bar])
   - Header CART (n) counter ([data-anya-cart-count])
   ============================================================ */
(function () {
  'use strict';

  var DISMISS_KEY = 'anya:location-bar:dismissed';

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* private mode — ignore */
    }
  }

  /* ---------------- Country selector dropdown ---------------- */
  function initSelector(root) {
    var toggle = root.querySelector('[data-loc-toggle]');
    var panel = root.querySelector('[data-loc-panel]');
    var input = root.querySelector('[data-loc-input]');
    var label = root.querySelector('[data-loc-label]');
    var form = root.querySelector('form');
    var featuredView = root.querySelector('[data-loc-view="featured"]');
    var othersView = root.querySelector('[data-loc-view="others"]');
    var mode = root.getAttribute('data-loc-mode') || 'instant';

    if (!toggle || !panel || !input || !form) return;

    function showView(name) {
      if (featuredView) featuredView.hidden = name !== 'featured';
      if (othersView) othersView.hidden = name !== 'others';
    }

    function onOutsideClick(event) {
      if (!root.contains(event.target)) close();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    }

    function open() {
      panel.hidden = false;
      // root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      showView('featured');
      document.addEventListener('click', onOutsideClick);
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      panel.hidden = true;
      // root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onOutsideClick);
      document.removeEventListener('keydown', onKeydown);
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) open();
      else close();
    });

    panel.addEventListener('click', function (event) {
      if (event.target.closest('[data-loc-others]')) {
        showView('others');
        return;
      }

      if (event.target.closest('[data-loc-back]')) {
        showView('featured');
        return;
      }

      var option = event.target.closest('[data-loc-option]');
      if (!option) return;

      input.value = option.getAttribute('data-value');
      if (label) label.textContent = option.getAttribute('data-toggle-label');

      root.querySelectorAll('[data-loc-option].is-selected').forEach(function (el) {
        el.classList.remove('is-selected');
        el.removeAttribute('aria-current');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-current', 'true');

      close();

      if (mode === 'instant') {
        // The visitor picked a location deliberately — no need to show the first-visit bar again.
        storageSet(DISMISS_KEY, '1');
        form.submit();
      }
    });
  }

  /* ---------------- First-visit location bar ---------------- */
  function initLocationBar() {
    var bar = document.querySelector('[data-location-bar]');
    if (!bar) return;

    // Fallback reveal in case the inline section script didn't run.
    if (bar.hasAttribute('hidden') && !storageGet(DISMISS_KEY)) {
      bar.removeAttribute('hidden');
    }

    var continueBtn = bar.querySelector('[data-loc-bar-continue]');
    var closeBtn = bar.querySelector('[data-loc-bar-close]');
    var form = bar.querySelector('[data-loc-selector] form');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        storageSet(DISMISS_KEY, '1');
        bar.setAttribute('hidden', '');
      });
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        storageSet(DISMISS_KEY, '1');
        if (form) form.submit();
        else bar.setAttribute('hidden', '');
      });
    }
  }

  /* ---------------- CART (n) counter ---------------- */
  function refreshCartCount() {
    var counters = document.querySelectorAll('[data-anya-cart-count]');
    if (!counters.length) return;

    var cartUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_url ? window.theme.routes.cart_url : '/cart';

    fetch(cartUrl + '.js', {headers: {Accept: 'application/json'}})
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-pill').forEach(function (el) {
          el.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
        });
      })
      .catch(function () {
        /* network error — keep the last rendered count */
      });
  }

  function init() {
    document.querySelectorAll('[data-loc-selector]').forEach(initSelector);
    initLocationBar();

    ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded'].forEach(function (eventName) {
      document.addEventListener(eventName, refreshCartCount);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
